import { createSelector } from 'reselect'

const getArtistCaseStudies = state => state.artistCaseStudies
const getArtistData = createSelector(
  [getArtistCaseStudies],
  artist => artist.get('data')
)

const getBioList = list => (
  list ? list.map(item => ({
    title: item.get('bio_list_title'),
    body: item.get('bio_list_body')
  })) : null
)

const getPressCoverImage = item => (
  (item && item.get('cover_image'))
  ? {
    id: item.getIn(['cover_image', 'ID']),
    imageSource: item.getIn(['cover_image', 'sizes', 'thumbnail']),
    width: item.getIn(['cover_image','width']),
    height: item.getIn(['cover_image','height'])
  } : null
)

const getPressFile = item => (
  (item && item.get('file_download'))
  ? {
    id: item.getIn(['file_download', 'ID']),
    url: item.getIn(['file_download', 'url']),
    filename: item.getIn(['file_download', 'filename']),
    title: item.getIn(['file_download', 'title']),
    mimeType: item.getIn(['file_download', 'mime_type']),
  } : null
)

const getPressMimeType = item => (
  (item && item.get('file_download'))
  ? item.getIn(['file_download', 'mime_type'])
  : 'application/jpg'
)

const getPressFileType = item => {
  let str = getPressMimeType(item)
  const indexOf = str.lastIndexOf('/')
  if (indexOf !== -1) { 
    str = str.substr(indexOf + 1)
  }
  return str.toUpperCase()
}

const getPressCategory = item => {
  let category = item && item.get('press_category')

  if (category && category.length > 1) { 
    category = `${category} / `
  }

  return category
}

const getPressTitle = item => item && item.get('press_release_title')
const getPressSubtitle = item => item && item.get('press_release_sub_title')

export const getArtistPress = createSelector(
  [getArtistData],
  data => {
    if (data) {
      const press = data.get('press')
      if (press) {
        return press.map(item => (
          {
            coverImage: getPressCoverImage(item),
            fileDownload: getPressFile(item),
            fileType: getPressFileType(item),
            category: getPressCategory(item),
            subtitle: getPressSubtitle(item),
            title: getPressTitle(item)
          }
        ))
      }
    }
  }
)

export const getArtistBioModules = createSelector(
  [getArtistData],
  data => {
    if (data) {
      const biography = data.get('biography')
      if (biography) {
        return biography.map(module => (
          {
            layout: module.get('acf_fc_layout'),
            body: module.get('bio_body'),
            title: module.get('bio_title'),
            list: getBioList(module.get('bio_list')),
            colSpan: module.get('bio_width') || 6,
            xOffset: module.get('bio_xoffset') || 2,
            yOffset: module.get('bio_yoffset') || 2
          }
        ))
      }
    }
    return data
  }
)



// WEBPACK FOOTER //
// ./src/components/artist-bio/selectors.js